<div class="grid-cell">
  <button
    mat-icon-button
    (click)="previousClicked.emit()"
    [disabled]="shownIdx() <= 0"
    class="previous"
    [class.not-visible]="!visible()"
    >
    <mat-icon>arrow_back_ios_new</mat-icon>
  </button>
</div>
<div class="grid-cell center-content">
  <div
    pcpSwiper
    [swiperIndex]="shownIdx()"
    [update$]="updateSwiper$"
    (swipe)="swipe($event)"
    class="swiper length{{ visibleCount() }}"
    [class.not-visible]="!visible()"
    >
    <!-- class "length2" eliminates layout shift while opening the extension slide navigation -->
    <div class="swiper-wrapper">
      @for (basicSlide of slides(); track basicSlide; let idx = $index) {
        <div class="swiper-slide">
          <div class="thumb-labels-wrapper" (click)="slideClicked.emit(basicSlide)">
            @if (isChapterOrLectionWithoutPreview(basicSlide)) {
              <div class="thumb text text-chapter">
                <div class="text-border">
                  <div class="text-cropper" [innerHTML]="basicSlide.caption | lineBreaks"></div>
                </div>
              </div>
            }
            @if (showCaption(basicSlide)) {
              <span class="textboard_headline">{{ basicSlide.caption }}</span>
            }
            @if (!isChapterOrLectionWithoutPreview(basicSlide)) {
              <img
                loading="lazy"
                [src]="basicSlide.previewpicture.thumb_n"
                [alt]="'Vorschau: ' + basicSlide.caption"
                class="thumb"
                />
            }
            <div class="thumb-labels">
              @if (isPrevious()) {
                <h4>{{ 'next-slide-preview.thumbs.previous' | transloco }}</h4>
              }
              @if (idx === currentSlideIdx()) {
                <h4>{{ 'next-slide-preview.thumbs.current' | transloco }}</h4>
              }
              @if (isNext()) {
                <h4>{{ 'next-slide-preview.thumbs.next' | transloco }}</h4>
              }
              <h4 class="slide-counter">{{ idx + 1 }}/{{ slides().length }}</h4>
            </div>
            @if (basicSlide | isVideoSlide) {
              <mat-icon class="video-icon">play_arrow</mat-icon>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
<div class="grid-cell">
  <button
    mat-icon-button
    (click)="nextClicked.emit()"
    [disabled]="shownIdx() >= slides().length - 1"
    class="next"
    [class.not-visible]="!visible()"
    >
    <mat-icon class="ios-rotate180deg">arrow_back_ios_new</mat-icon>
  </button>
</div>
